module.exports = __webpack_public_path__ + "img/suppliers_wei.88c46a9f.png";